import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import db from "../../src/firebase/utils";
import { loadStripe } from '@stripe/stripe-js';
import { publishableKey } from './../stripe/config';
import DashAuthWrapper from './../components/DashAuthWrapper'
import firebase from 'firebase/app';
import Button from '../components/forms/Button';
import 'firebase/functions';

const mapState = ({ user }) => ({
	currentUser: user.currentUser,
})

export async function goToBillingPortal() {
	const functionRef = firebase
  		.app()
  		.functions('us-west3')
  		.httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink');
		const { data } = await functionRef({ returnUrl: window.location.origin });
		window.location.assign(data.url);
}

function Subscribe() {
	const [products, setProducts] = useState([]);
	const { currentUser } = useSelector(mapState);
	const [subscription, setSubscription] = useState(null);
	const [check, setCheck] = useState(true)

	function accept(){
		setCheck(!check)
	}

	useEffect(() => {
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, [])
  
	useEffect(() => {
	  db.collection("subscribers")
		.doc(currentUser.id)
		.collection("subscriptions")
		.get()
		.then((querySnapshot) => {
		  querySnapshot.forEach(async (subscription) => {
			setSubscription({
				status: subscription.data().status,
			  	current_period_end: subscription.data().current_period_end.seconds,
			  	current_period_start: subscription.data().current_period_start.seconds,
			});
		  });
		});
	}, [currentUser.id]);
  
	useEffect(() => {
	  db.collection("subscriptions")
		.where("active", "==", true)
		.get()
		.then((querySnapshot) => {
		  const products = {};
		  querySnapshot.forEach(async (productDoc) => {
			products[productDoc.id] = productDoc.data();
			const priceSnap = await productDoc.ref.collection("prices").get();
			priceSnap.docs.forEach((price) => {
			  products[productDoc.id].prices = {
				priceId: price.id,
				priceData: price.data(),
			  };
			});
		  });
		  setProducts(products);
		});
	}, []);
  
	const loadCheckout = async (priceId) => {
	  const docRef = await db
		.collection("subscribers")
		.doc(currentUser.id)
		.collection("checkout_sessions")
		.add({
		  price: priceId,
		  success_url: window.location.origin,
		  cancel_url: window.location.origin,
		});
  
	  docRef.onSnapshot(async (snap) => {
		const { error, sessionId } = snap.data();
  
		if (error) {
		  // Show an error to your customer and
		  alert(`An error occured: ${error.message}`);
		}
  
		if (sessionId) {
		  const stripe = await loadStripe(publishableKey);
		  stripe.redirectToCheckout({ sessionId });
		}
	  });
	};

	console.log(products)
  
	return (
		<DashAuthWrapper >
		<div className="plansScreen">
			<h1>Manage Subscription</h1>
			
			{subscription && (
			<p>
				Renewal date:{" "}
				{new Date(
				subscription?.current_period_end * 1000
				).toLocaleDateString()}
			</p>
			)}
			{Object.entries(products).map(([productId, productData]) => {
			
				let isCurrentPackage = false;
				if(subscription){
					isCurrentPackage = true;
				}
			 
				
			return (
				<div
					key={productId}
					className={`${isCurrentPackage && "plansScreen__plan--disabled"} plansScreen__plan`}
				>
					<div className="plansScreen__info">
						<h5>{productData.name}</h5>
						<h6>{productData.description}</h6>
					</div>
		
					{/* <button
						onClick={() =>!isCurrentPackage && loadCheckout(productData.prices.priceId)}
					>
						{isCurrentPackage ? "Current Package" : "Subscribe"}
					</button> */}
					{isCurrentPackage ?(
						<button
							onClick={() => {goToBillingPortal()}}
						>
							Manage
						</button>
					):(
						<div>
							<div className="col text-right">
								<Button className="btn"
									onClick={() => !isCurrentPackage && loadCheckout(productData.prices.priceId)} disabled={check}
								>
									Subscribe
								</Button>
							</div>
							<div className="row col d-flex mx-auto justify-content-end mt-3">
								<div className="checkBox mr-2" onClick={accept}>
									{!check &&(
										<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 check" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
										</svg>
									)}
								</div>
								<p>I accept the</p> 
								<Link to="/termsAndConditions" className="t_C ml-1">
									Terms and Conditions
								</Link>
							</div>
						</div>
					)}
				</div>
			);
			})}
		</div>
		</DashAuthWrapper>
	);
  }
  
  export default Subscribe;
